import React from 'react';
import { TextField, Autocomplete } from '@mui/material';
import { useField } from 'formik';

const AutocompleteWrapper = ({ name, options, label, disabled, id, ...otherProps }) => {
  const [field, mata] = useField(name);
  // Refactor Code
  // eslint-disable-next-line no-unused-vars

  const configAutocomplete = {
    ...otherProps,
    fullWidth: true,
    variant: 'outlined',
  };

  if (mata && mata.touched && mata.error) {
    configAutocomplete.error = true;
    configAutocomplete.helperText = mata.error;
  }

  const configTextField = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: 'outlined',
    //onChange: handleChange,
  };

  if (mata && mata.touched && mata.error) {
    configTextField.error = true;
    configTextField.helperText = mata.error;
  }

  return (
    <Autocomplete
      options={options}
      id={id}
      getOptionLabel={(option) => option.label}
      disabled={disabled}
      // value = {value}
      // onChange={(event, value) => {
      // 	setFieldValue(name, value.value);
      // 	setValue(value);
      //   }}
      {...configAutocomplete}
      renderInput={(params) => <TextField {...params} {...configTextField} label={label} />}
    />
  );
};

export default AutocompleteWrapper;
